import { useRef, useState } from 'react';

const SCROLL_RATE = 5;
const SCROLL_DEAD_ZONE = 10;

type Props = {
  isMobile: boolean;
};

export function useScrollFilterBar({ isMobile }: Props) {
  const [horizontalScroll, setHorizontalScroll] = useState(0);
  const [movingScroll, setMovingScroll] = useState(0);
  const [intervalFunction, setIntervalFunction] =
    useState<NodeJS.Timeout | null>(null);
  const filterRef = useRef<HTMLDivElement>(null);

  const scrollFilter = (value: number) => {
    filterRef.current!.scrollLeft += value;
    setHorizontalScroll(filterRef.current!.scrollLeft);
  };

  const clearIntervalScroll = () => {
    if (intervalFunction !== null) {
      clearInterval(intervalFunction);
      setIntervalFunction(null);
    }
    setMovingScroll(0);
  };

  const touchStart = ({ direction }: { direction: 'left' | 'right' }) => {
    const value = direction === 'left' ? -SCROLL_RATE : SCROLL_RATE;
    setMovingScroll(value);
    setIntervalFunction(setInterval(() => scrollFilter(value), 20));
  };

  const touchEnd = () => clearIntervalScroll();

  const touchFilterBar = () => {
    clearIntervalScroll();
    setHorizontalScroll(filterRef.current!.scrollLeft);
  };

  // Used to clear the intervalFunction in the case a long touch gets to a point where the arrow disappears.
  if (isMobile) {
    const leftScrollFinished =
      movingScroll < 0 && horizontalScroll - SCROLL_DEAD_ZONE < 0;
    const rightScrollFinished =
      movingScroll > 0 &&
      filterRef.current !== null &&
      horizontalScroll + SCROLL_DEAD_ZONE >
        filterRef.current.scrollWidth - filterRef.current.clientWidth;

    if (leftScrollFinished || rightScrollFinished) {
      clearIntervalScroll();
    }
  }

  const showLeftScroll = horizontalScroll - SCROLL_DEAD_ZONE > 0;
  const showRightScroll =
    filterRef.current !== null &&
    horizontalScroll + SCROLL_DEAD_ZONE <
      filterRef.current.scrollWidth - filterRef.current.clientWidth;

  return {
    touchStart,
    touchEnd,
    touchFilterBar,
    filterRef,
    showLeftScroll,
    showRightScroll,
  };
}
